import {
    getField,
    updateField
} from "vuex-map-fields"
import {requestCreate, requestUpdate, requestDelete, sendRequest} from "../../api"
import {
    ADD_ROW, CALCULATE_ROW, REMOVE_ROW, RESET_FORM, SET_FORM
} from "../../constant-types"

const getDefaultState = () => {
    return {
        form: getDefaultFormState()
    }
}

const getDefaultFormState = () => ({
    id: '',
    warehouse_id: '',
    audit_by_id: '',
    status_processed: false,
    total_qty_difference: 0,
    total_price_modal_difference: 0,
    stock_audit_items: []
})

const getDefaultItemFormState = () => ({
    id: '',
    stock_audit_id: '',
    product: null,
    product_id: '',
    n_price_modal: 0,
    qty_balance_actual: 0,
    qty_balance_data: 0,
    qty_difference: 0,
    price_modal_difference: 0
})

export default ({
    namespaced: true, 
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [ADD_ROW](state) {
            state.form.stock_audit_items.push(getDefaultItemFormState())
        },
        [REMOVE_ROW](state, idx) {
            state.form.stock_audit_items.splice(idx, 1)
        },
        [RESET_FORM](state) {
            Object.assign(state, getDefaultState())
        },
        RESET_ITEM_FORM(state) {
            state.form.stock_audit_items = []
        },
        [CALCULATE_ROW](state, idx) {
            let relatedItem = state.form.stock_audit_items[idx]
            relatedItem.qty_difference = relatedItem.qty_balance_actual - relatedItem.qty_balance_data
            relatedItem.price_modal_difference  = relatedItem.qty_difference * relatedItem.n_price_modal
        },
        CALCULATE_TOTAL(state) {
            state.form.total_qty_difference = _.sumBy(state.form.stock_audit_items, 'qty_difference');
            state.form.total_price_modal_difference = _.sumBy(state.form.stock_audit_items, 'price_modal_difference');
        },
        [SET_FORM](state, payload) {
            state.form = payload
        },
        SET_BALANCE_DATA(state, { idx, qtyBalanceData }){
            state.form.stock_audit_items[idx].qty_balance_data = qtyBalanceData
        },
        updateField
    },
    // can async
    actions: {
        loadForm({commit, state}, stockAuditId) {
            return sendRequest(`stock-audit/${stockAuditId}`, {}, 'get', (successResponse) => {
                commit('SET_FORM', successResponse)
            });
        },
        loadBalanceDataFromStockWarehouse({commit, state}, { productId, idx }) {
            let warehouseId = state.form.warehouse_id
            return sendRequest('stock-warehouse/get-balance', { warehouseId, productId }, 'get', (successResponse) => {
                commit('SET_BALANCE_DATA', { idx, qtyBalanceData : successResponse })
                commit(CALCULATE_ROW, idx)
                commit('CALCULATE_TOTAL')
            },() => {}, () => {}, true, false, true)
        },
        requestCreateAudit({
            commit,
            state
        }) {
            requestCreate('stock-audit', state.form, commit, '', '', '', (successResponse) => {
                // add in list
                commit('stockAudit/ADD_IN_LIST', successResponse, { root: true })
                // reset form
                commit(RESET_FORM)
            })
        },
        requestUpdateAudit({
            commit,
            state
        }) {
            requestUpdate(`stock-audit/${state.form.id}`, state.form, commit, '', '', '', (successResponse) => {
                // update in list
                commit('stockAudit/UPDATE_IN_LIST', successResponse, { root: true })
            })
        },
        requestDeleteAudit({
            commit,
            state
        }, stockAudit) {
            requestDelete(`stock-audit/${stockAudit.id}`, {}, commit, `ID.Audit : ${stockAudit.id}`, '', '', '', (successResponse) => {
                // remove in list
                commit('stockAudit/REMOVE_IN_LIST', successResponse, { root: true })
            })
        },
    },
    // call variable with custom display
    getters: {
        getField,
        validateHasDuplicateProduct: state => {
            // should not have same product_id
            return state.form.stock_audit_items.some((i, idx) => {
                return state.form.stock_audit_items.findIndex(fi => fi.product_id === i.product_id) !== idx
            })
        },
        formNotValidated: (state, getters) => {
            return getters.validateHasDuplicateProduct
        }
    }
})

